
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommRepairItemsBOMGrid extends Serenity.EntityGrid<ECommRepairItemsBOMRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommRepairItemsBOM'; }
        protected getDialogType() { return ECommRepairItemsBOMDialog; }
        protected getIdProperty() { return ECommRepairItemsBOMRow.idProperty; }
        protected getInsertPermission() { return ECommRepairItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommRepairItemsBOMRow.localTextPrefix; }
        protected getService() { return ECommRepairItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}